import * as React from 'react';
import { IChannel } from '../../../../data/api/models';
import * as Commonmark from 'react-commonmark';
import { FaExternalLinkAlt } from 'react-icons/fa';
interface IFooterProps {
  channel: IChannel;
}
export default class Footer extends React.Component<IFooterProps, any> {
  public render() {
    const { channel } = this.props;

    return (
      <footer>
        <div className="container">
          <div className={'footer-container'}>
            <div className={'footer-info'}>
              <div>
                <img src={require('../../Img/admiral_logo.png')} alt="Admiral" width={'100px'}/>
              </div>
              <Commonmark source={channel.footer} linkTarget="_blank"/>
            </div>
            <div className={'footer-need-some-help'}>
              <div className={'f-title'}>Need some help?</div>
              <div className={'f-link'}><FaExternalLinkAlt/><a href={'https://www.admiral.com/existing-customers/make-a-claim.php'} target={'_blank'}>Make a claim</a></div>
              <div className={'f-link'}><FaExternalLinkAlt/><a href={'https://www.admiral.com/travel-insurance/FAQs'} target={'_blank'}>Frequently asked questions</a></div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}
